export const workflowNextRunsMaxCount = 20;

export const workflowNextRunsInitialDataCount = 10;
